import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingAction } from '../../common/models/callback';
import RegularButton from '../RegularButton';
import ModalWindow from '../ModalWindow';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';
import styles from './styles.module.scss';

interface IProps {
  isShown: boolean;
  titleText: IFormattedMessage;
  descriptionText: IFormattedMessage;
  confirmBttnText?: IFormattedMessage;
  cancelBttnText?: IFormattedMessage;
  onConfirm: IBindingAction;
  onCancel: IBindingAction;
}

const ConfirmationModal: FunctionComponent<IProps> = ({
  isShown,
  titleText,
  descriptionText,
  confirmBttnText = { id: 'confirm', defaultMessage: 'Confirm' },
  cancelBttnText = { id: 'cancel', defaultMessage: 'Cancel' },
  onConfirm,
  onCancel
}) => (
  <ModalWindow
    contentClassName={`${styles.confirmModalContent} modal-wrapper`}
    isShown={isShown}
    onHide={onCancel}
  >
    <div className={styles.modalBody}>
      <div className="custom-modal-header">
        <FormattedMessage {...titleText} />
      </div>
      <div className={styles.modalInfo}>
        <FormattedMessage {...descriptionText} />
      </div>
      <div className={styles.modalBttns}>
        <RegularButton
          onClick={onCancel}
          variant="tertiary"
          textIntlId={cancelBttnText.id}
          defaultMessage={cancelBttnText.defaultMessage}
        />
        <RegularButton
          onClick={onConfirm}
          textIntlId={confirmBttnText.id}
          defaultMessage={confirmBttnText.defaultMessage}
        />
      </div>
    </div>
  </ModalWindow>
);

export default ConfirmationModal;
